import { render, staticRenderFns } from "./LoginSettings.vue?vue&type=template&id=3328a606&"
import script from "./LoginSettings.vue?vue&type=script&lang=js&"
export * from "./LoginSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports